<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-01
      	描述：插件中心-分销-分销订单
      -->
  <div class="user">
    <!-- 111111 -->
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="姓名"><el-input size="small" v-model="searchForm.username"
            placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="电话号"><el-input size="small" v-model="searchForm.mobile "
            placeholder="请输入电话号"></el-input>
        </el-form-item>
        <el-form-item label="身份证号"><el-input size="small" v-model="searchForm.usernum"
            placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="nav" style="background-color: #fff !important">
      <div @click="ddxq(2)">
        <div :class="show == 2 ? 'dtclass' : ''">百融风控报告</div>
      </div>
      <div @click="ddxq(13)">
        <div :class="show == 13 ? 'dtclass' : ''">租先知</div>
      </div>
    </div>
    
    <!-- 百融分控 -->
    <!-- 租先知 -->

    <template v-if="show == 2">
      <Fengkon ></Fengkon>
    </template>
    <!-- <template v-if="show == 13">
      <ZUXIANZHI></ZUXIANZHI>
    </template> -->
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import Fengkon from "./dialog/detail.vue";
// import ZUXIANZHI from "./dialog/zuXianZhi.vue";

export default {
  components: {
    Fengkon,
    // ZUXIANZHI
  },
  data() {
    return {
      searchForm:{
        username: "", //姓名
        mobile: "", //手机号
        usernum: "", //身份证
      },
      some: "",
      show: 2
    }
  },
  props: {},
  created() {
    /*获取列表*/
    // this.getData();
  },
  methods: {
    // 显示报告
    ddxq(val) {
      this.show = val;
    }, 
    onSubmit() {
      // cha
      console.log(this.searchForm);
    },
    /*获取数据*/
    getData() {
      let self = this;
      let Params = {
        order_id: "",
        user_id: "",
        source_type: 2,
        username: "杜高达", //姓名
        usernum: "330281199110086436", //身份证
        mobile: "19106588239" //手机号
      };
      OrderApi.getControl(Params, true)
        .then(data => {
          console.log(data, "看看你看卡");
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style scoped="">
.referee-name {
  width: 33.333333%;
}

.dialogFile {
  .el-dialog__header {
    background-color: #d9d9d9;
  }

  .el-dialog__body {
    background-color: #d9d9d9;
  }
}

.color49 {
  color: #495060;
}

.xtsh {
  cursor: pointer;
  color: #ffcf00;
  font-weight: bold;
  font-size: 18px;
}

.nav {
  width: 96%;
  height: 70px;
  border-bottom: 1px solid #e8edf0;
  margin: 10px 0;
  display: flex;
  padding: 0 10px;
}

.nav div div {
  width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #d8e0e6;
  border: 1px solid #d8e0e6;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #7a9191;
  margin-top: 20px;
  margin-right: 6px;
}

.nav div .dtclass {
  background-color: #ffffff;
}

.jbxx {
  width: 100%;
  height: 450px;
  display: flex;
  color: white;
}

.jbxx .j_left {
  width: 25%;
  background-color: #6495ed;
  margin-right: 1%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.jbxx .j_left div {
  width: 100%;
  text-align: center;
  margin: 10px 0;
}

.jbxx .j_left .touximg {
  display: flex;
  justify-content: center;
  color: #f6363e;
}

.jbxx .j_left div img {
  width: 100px;
  height: 100px;
}

.jbxx .j_right {
  width: 70%;
  background-color: #6495ed;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: row;
}

.jbxx .j_right .rleft {
  width: 50%;
}

.jbxx .j_right div {
  margin: 10px 0;
}

.jbxx .j_right div {
  margin: 0;
  line-height: 2.5;
}

.jbxx .j_right .dingdan {
  display: flex;
  align-items: center;
  height: 50px;
  color: white;
}

.dd_title {
  font-size: 16px;
}

.jbxx .j_right .dingdan .d1 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #ffa49f;
  margin: 0 5px;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .dingdan .d2 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #c4efa2;
  margin: 0 5px;
  padding: 5px;
  background-color: #f6ffed;
  color: #76cc67;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .dingdan .d3 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #c4efa2;
  margin: 0 5px;
  padding: 5px;
  background-color: #f6ffed;
  color: #76cc67;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .rright {
  width: 50%;
}

.jbxx .j_right .rright div {
  margin-bottom: 30px;
}

.jbxx .j_right .rright div img {
  width: 200px;
  height: 130px;
}

.orderlist {
  display: flex;
  justify-content: flex-start;
}

.d4 {
  width: 80px;
  text-align: center;
  list-style: none;
  border: 1px solid #ffa49f;
  margin: 0 5px;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
}

.anniu {
  margin-bottom: 5px;
}

/* .nav div .dtclass {
  background-color: #ffffff;
} */
</style>



// WEBPACK FOOTER //
// src/views/order/control/index.vue